import { render, staticRenderFns } from "./HeaderECommerce.vue?vue&type=template&id=c1040b8c&"
import script from "./HeaderECommerce.vue?vue&type=script&lang=js&"
export * from "./HeaderECommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports